(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["live/block-live-visibility-detection"] = factory();
	else
		root["live/block-live-visibility-detection"] = factory();
})(globalThis, () => {
return 